import { Badge } from "V2.0/common/badge";

export default ConditionRulesList;

function ConditionRulesList({ node, onSelect }) {
  const availableBranches = node.data.rules;

  return (
    <div className="flex flex-col gap-y-4">
      {availableBranches.map((rule) => (
        <Badge
          className="hover:cursor-pointer"
          key={rule.outputPort}
          onClick={() => onSelect(rule)}
        >
          {rule.field} {rule.operator} {rule.value}
        </Badge>
      ))}

      <Badge
        className="hover:cursor-pointer"
        key="default"
        onClick={() =>
          onSelect({ outputPort: node.data.defaultPort, name: "Default" })
        }
      >
        Default
      </Badge>
    </div>
  );
}
